import styled from '@emotion/styled'

export const BasicInfoFormWrapper = styled.div`
  position: relative;
`
